export const RELATION = {
  APPRAISER: 'APPRAISER',
  COAPPRAISER: 'COAPPRAISER',
  TEAMMANAGER: 'TEAMMANAGER',
};
